import React from 'react';
import useStateCallback from '../common/useStateCallback'

const InputComponent  = React.memo((props) => {
       return <>
    <div className={`sas-input  ${props.invalid} ${props.focused}`} >
    <label className="form-field" element="formField">
        <input  type="text" value={props.value} name={props.name} className="slot-content" onFocus={props.onFocusInput} onBlur={props.onBlurInput} onChange={props.onChangeInput}/>
        
        <div className="label" element="label">{props.label}</div>
        {props.name === 'org' && props.orgNumberValid &&
        <svg class="sas-icon search-icon sas-icon-cl--info-circle info-icon-sprite" role="presentation" >
           <use href="#cl--check-circle"></use>
        </svg>
        }
        </label>
        <span className="message" element="message">{props.error}</span>
        </div>
    </>
});
export default InputComponent;
